import { render, staticRenderFns } from "./UserItemCreate.vue?vue&type=template&id=ff2d43c6"
import script from "./UserItemCreate.vue?vue&type=script&lang=js"
export * from "./UserItemCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports